import React, { Component } from 'react';
import './Login.css';
import { GOOGLE_AUTH_URL } from '../../../config';
import { Redirect } from 'react-router-dom'
import googleLogo from '../../../assets/svg/google-logo.png';
import {
    Grid,
    Container,
    Typography,
    Chip,
    Avatar
} from "@material-ui/core";

class Login extends Component {

    componentDidMount() {
        if (this.props.location.state && this.props.location.state.error) {
            setTimeout(() => {
                this.props.enqueueSnackbar(this.props.location.state.error, { variant: 'error' });
                this.props.history.replace({
                    pathname: this.props.location.pathname,
                    state: {}
                });
            }, 100);
        }
    }

    render() {
        if (this.props.isAuthenticated) {
            return <Redirect
                to={{
                    pathname: "/home",
                    state: { from: this.props.location }
                }} />;
        }

        return (
            <Container maxWidth={false} className="loading-position-login" >
                <Grid container direction="row" justifyContent="center" alignItems="center" spacing={2} >
                    <Grid item container direction="column" xs={12} sm={12} md={7} lg={5} xl={5} style={{ textAlign: 'center', marginTop: '10%' }}>
                        <Typography variant="h3" className="login-title"> <b>Welcome to Asset Inventory Manager</b></Typography>
                        <div style={{ textAlign: 'center', marginTop: '40px' }}>
                            <Chip
                                className="custom-chip"
                                onClick={() => window.open(GOOGLE_AUTH_URL, "_self")}
                                avatar={<Avatar src={googleLogo} alt="Google" style={{ width: 40, height: 40 }} />}
                                label={<Typography variant="h6">Login with Google</Typography>} />
                        </div>
                    </Grid>
                </Grid>
            </Container>
        );
    }
}

export default Login
